import { Component, inject, Input } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { FeelsMoreConfidentEnum } from '@isophi/pap-api';

@Component({
    selector: 'isophi-app-emoji-rating-display',
    templateUrl: './emoji-rating-display.component.html',
    styleUrls: ['./emoji-rating-display.component.scss'],
    standalone: false
})
export class EmojiRatingDisplayComponent {
  translocoService = inject(TranslocoService);

  @Input() value: FeelsMoreConfidentEnum | null = null;

  getEmojiData() {
    switch (this.value) {
      case FeelsMoreConfidentEnum.StronglyDisagree:
        return {
          icon: 'assets/img/emojis/smile-no-active.svg',
          label: this.translocoService.translate('shared/no')
        };
      case FeelsMoreConfidentEnum.Disagree:
        return {
          icon: 'assets/img/emojis/smile-rather-no-active.svg',
          label: this.translocoService.translate('shared/ratherNo')
        };
      case FeelsMoreConfidentEnum.Agree:
        return {
          icon: 'assets/img/emojis/smile-rather-yes-active.svg',
          label: this.translocoService.translate('shared/ratherYes')
        };
      case FeelsMoreConfidentEnum.StronglyAgree:
        return {
          icon: 'assets/img/emojis/smile-yes-active.svg',
          label: this.translocoService.translate('shared/yes')
        };
      default:
        return {
          icon: 'assets/img/emojis/smile-rather-no.svg',
          label: this.translocoService.translate('shared/blank')
        }
    }
  }
}
